// libs
import { Record, List } from "immutable";
import moment from "moment";
import CalendarEventItem from "./CalendarEventItem";
import CalendarDateItem from "./CalendarDateItem";

moment.locale("ja");

const today = moment();

const BaseRecord = Record({
  items: List(),
  dayElements: List(),
  hasNext: false,
  hasPrev: false,
  now: today,
  selected: today
});

export default class Calender extends BaseRecord {
  init(data) {
    let newItems = List();

    try {
      data.map((item, i) => {
        newItems = newItems.push(new CalendarEventItem().init(item, i));
      });
    } catch (e) {
      console.log(e);
    }

    let newState = this.set("items", newItems);
    newState = newState.updateMonth(0);

    return newState;
  }

  prevMonth() {
    return this.updateMonth(-1);
  }

  nextMonth() {
    return this.updateMonth(1);
  }

  updateMonth(diff) {
    const selected = this.selected.clone().add(diff, "months");
    // const prevMonth = selected.clone().add(-1, "months");
    const nowFistDateOfMonth = moment().date(1);

    return this.withMutations(s =>
      s.set("selected", selected)
       .set("hasNext", selected.diff(nowFistDateOfMonth, "months") < 1)
       .set("hasPrev", selected.diff(nowFistDateOfMonth, "months") > 0)
       .set("dayElements", this.getDayElements(selected))
    );
  }

  selectDate(selected) {
    const nowFistDateOfMonth = moment().date(1);

    return this.withMutations(s =>
      s.set("selected", selected)
       .set("hasNext", selected.diff(nowFistDateOfMonth, "months") < 1)
       .set("hasPrev", selected.diff(nowFistDateOfMonth, "months") > 0)
       .set("dayElements", this.getDayElements(selected))
    );
  }

  getDayElements(date) {
    let elements = List();
    const startIndex = parseInt(date.clone().date(1).format("e"));
    const length = 7 * 6;
    const firstDate = date.clone().date(1);
    let dateClone = firstDate.subtract(startIndex, "day");
    // const isNowYear = date.format("gggg") === this.now.format("gggg");
    // const isNowMonth = date.format("M") === this.now.format("M");
    let isPast = false;
    let isOverSevenDays = false;
    let isToday = false;

    // console.log(this.now.format(), "最初の曜日", date.clone().date(1).format("dddd"), startIndexß);
    // console.log(date.format(), this.now.format());

    for (let i = 0; i < length; i++) {
      dateClone = dateClone.add(1, "days");
      const day = dateClone.format("D");
      isToday = day.toString() === this.now.format("D") && dateClone.isSame(this.now, "month");
      isPast = dateClone.isBefore(this.now, "day");
      isOverSevenDays = dateClone.diff(this.now, "days") >= 7;
      const isExternalMonth = dateClone.format("M") !== date.format("M");
      const isPrevMonth = dateClone.isBefore(date, "month");
      const isNextMonth = dateClone.isAfter(date, "month");
      // console.log(this.now.format("MM/DD"), dateClone.format("MM/DD"), isPrevMonth, isNextMonth);

      const data = {
        index: i,
        day: dateClone.format("D"),
        week: dateClone.format("ddd"),
        isPast: isPast,
        isOverSevenDays: isOverSevenDays,
        isToday: isToday,
        isHoliday: false,
        isExternalMonth: isExternalMonth,
        isPrevMonth: isPrevMonth,
        isNextMonth: isNextMonth,
        eventItems: [] // CalendarEventItem
      };

      this.items.forEach((item) => {
        if (item.date.format("MM-DD-YYYY") === dateClone.format("MM-DD-YYYY")) {
          if (item.isHoliday) {
            data.isHoliday = true;
          }

          data.eventItems.push(item);
        }
      });

      elements = elements.push(new CalendarDateItem().init(data));
    }
    // console.log(elements);
    return elements;
  }
}



// WEBPACK FOOTER //
// ./src/js/models/Calendar.js